class BundleForm {
  constructor(el) {
    this.el = el;
    this.inputs = Array.from(el.querySelectorAll('input[type=radio]') ?? []);

    this.init();
  }

  handleBundleSelected(ev) {
    console.log('Got the event ', ev);
    window.dispatchEvent(new CustomEvent('bundle.select', {
      detail: {
        visitors: JSON.parse(ev.target.value),
        name: ev.currentTarget.dataset.name ?? null,
      },
    }));

    const scrollableElement = document.querySelector(this.el.dataset.target ?? '#invalid-selector');

    if (scrollableElement) {
      const location = scrollableElement.getBoundingClientRect().top + window.scrollY;
      const offset = 200;

      window.scrollTo(0, location - offset);
    }
  }

  handleBundleReset(ev) {
    this.inputs.forEach((input) => {
      input.checked = false;
    });
  }

  init() {
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleBundleSelected.bind(this));
    });

    window.addEventListener('bundle.reset', this.handleBundleReset.bind(this));
  }
}

export default BundleForm;
